import { Grid, InputLabel, styled } from '@mui/material'

export const AppFormInputLabel = styled(InputLabel)(({ theme }) => ({
  ...theme.typography.caption,
  marginBottom: theme.spacing(0.5),
  color: theme.palette.text.primary
}))

export const AppFormGridColumn = styled(Grid)(({ theme }) => ({
  paddingRight: theme.spacing(2),

  '&.MuiGrid-root': {
    paddingTop: 0
  },

  '& + .MuiGrid-item': {
    borderLeft: `1px solid ${theme.palette.divider}`,
    paddingTop: 0,
    paddingLeft: theme.spacing(2)
  }
}))
